import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccionEspecificaService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getAccionEspecifica(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaAeIndOp', { headers: this.header(this.token) });
  }

  getAccionEspecificaById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaAeIndOpById/' + id, { headers: this.header(this.token) });
  }

  postAccionEspecifica(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaAeIndRiesgos', bodyString, { headers: this.header(this.token) });
  }

  putAccionEspecifica(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);    
    return this.http.put(this.baseUrl + 'poaAccionEspecifica', bodyString, { headers: this.header(this.token) });
  }

  deleteAccionEspecifica(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaAccionEspecifica/' + id, { headers: this.header(this.token) });
  }

  // fRnk
  postAccionEspecificaOperacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaOpIndicador', bodyString, { headers: this.header(this.token) });
  }

  postAccionEspecificaOperaciones(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'postPoaOperaciones', bodyString, { headers: this.header(this.token) });
  }
  
  postOperacionIndicadores(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaIndicadores', bodyString, { headers: this.header(this.token) });
  }

  putAccionEspecificaOperacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaOpIndicador', bodyString, { headers: this.header(this.token) });
  }

  getListAccionEspecifica(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'poaAeIndOpByIdTecho/' + id, { headers: this.header(this.token) });
  }

  getListAccionEspecificaByTechoId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'accionEspecificaByTechoId/' + id, { headers: this.header(this.token) });
  }

  getListIndicadoresByOperacionId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'indicadoresByOperacionId/' + id, { headers: this.header(this.token) });
  }
}
